import { TextProps } from "../../types/textTypes";
import "./smaller.scss";

const Smaller: React.FC<TextProps> = ({ children, className }) => {
  return <p className={`smallerText ${className}`}>{children}</p>;
};

export default Smaller;
